import { StringAccessClaimRule, RestrictedStringAccessClaimRule } from "./StringAccessClaimRule.js";
const groupType = "group";
class Group {
  constructor(name) {
    this.name = name;
  }
  toString() {
    return this.name;
  }
  get type() {
    return groupType;
  }
}
class GroupAccessRule extends StringAccessClaimRule {
  constructor(group) {
    super(group, groupType);
  }
  getToStringPrefix() {
    return "Groups include";
  }
}
class RestrictedGroupAccessRule extends RestrictedStringAccessClaimRule {
  constructor(group) {
    super(group, groupType);
  }
  getToStringPrefix() {
    return "Groups do not include";
  }
}
export {
  Group,
  GroupAccessRule,
  RestrictedGroupAccessRule
};
//# sourceMappingURL=GroupAccessRule.js.map
